/**
 * 客源渠道模块
 */
import React, { useMemo } from 'react';
import { Input, Select } from 'antd';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { OccType, SourceChannelType } from '@/config/constant';
import { ChannelItem, StrategyItem, SourceChannelInfo } from '@/redux/reducers/reservation/base.d';
import { findItemByKey } from '@/redux/actions/reservation/helper';

import styles from './index.module.scss';

interface IProps {
  value: SourceChannelInfo;
  isThroughAudit: boolean; // 是否经过夜审
  channelList: ChannelItem[];
  strategyList: StrategyItem[];
  onChange: (value: Partial<SourceChannelInfo>) => void;
  getPopContainer: () => HTMLElement;
  occType: OccType;
}

interface ISelectOption {
  label: string;
  value: string | number;
}

const Index: React.FC<IProps> = (props) => {
  const {
    value,
    isThroughAudit,
    channelList,
    strategyList,
    onChange,
    getPopContainer,
    occType,
  } = props;
  const isHourType = occType === OccType.TimeRENT; // 是否是钟点房

  const channelOptions: ISelectOption[] = useMemo(() => {
    return (channelList || []).map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [channelList]);

  const strategyOptions: ISelectOption[] = useMemo(() => {
    return (strategyList || []).map((item) => ({
      label: item.showName,
      value: item.id,
    }));
  }, [strategyList]);

  const handleChannelChange: (channelId: number) => void = (channelId) => {
    onChange({ channelId });
  };

  const handleChargeStrategyChange: (strategyId: number) => void = (strategyId) => {
    onChange({ strategyId });
  };

  const handleOTAOrderChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange({ channelOrderNo: event.target.value });
  };

  const channelDetail = useMemo(() => {
    return (
      findItemByKey(channelList, 'id', value.channelId) || {
        type: SourceChannelType.WALK_IN,
        directFlag: false,
      }
    ); // 当前渠道详细信息
  }, [channelList, value.channelId]);
  const isDirectChannel = channelDetail.directFlag;
  const isOTAChannel = channelDetail.type === SourceChannelType.OTA; // ota渠道
  // 渠道信息是否可以变更 【直连渠道、已过夜审、钟点房】不可修改
  const isChannelDisabled = isDirectChannel || isThroughAudit || isHourType;

  return (
    <ContentBlock
      title={intl.get('reservation_channel_block_title')}
      className={styles.channelInfo}
    >
      <FormItem label={intl.get('app_reservation_channel_name')}>
        <Select
          placeholder={intl.get('reservation_field_select_default_placeholder')}
          options={channelOptions}
          value={value.channelId}
          onChange={handleChannelChange}
          disabled={isChannelDisabled}
          getPopupContainer={getPopContainer}
        />
      </FormItem>
      <FormItem label={intl.get('app_reservation_strategy_name')}>
        <Select
          placeholder={intl.get('reservation_field_select_default_placeholder')}
          options={strategyOptions}
          value={value.strategyId}
          disabled={isChannelDisabled}
          onChange={handleChargeStrategyChange}
          getPopupContainer={getPopContainer}
        />
      </FormItem>
      {isOTAChannel && !isDirectChannel ? (
        <FormItem label={intl.get('app_reservation_channel_no')}>
          <Input
            placeholder={intl.get('reservation_field_input_default_placeholder')}
            value={value.channelOrderNo}
            onChange={handleOTAOrderChange}
          />
        </FormItem>
      ) : null}
    </ContentBlock>
  );
};

export default Index;
